import { Flex, theme, Typography } from 'antd'
import { CircleSlash2 } from 'lucide-react'
import type { ReactNode } from 'react'

import { IconWithBackground } from 'src/components/IconWithBackground'
import { Text } from 'src/components/Text'
import { useIconSizes } from 'src/hooks'

export type EmptyProps = {
  color?: string
  icon?: ReactNode
  footer?: ReactNode
  title?: string
  description?: string
}

const ICON_BADGE_SIZE = 56

export const Empty = ({
  title,
  description,
  icon,
  color,
  footer
}: EmptyProps) => {
  const { token } = theme.useToken()
  const iconSizes = useIconSizes()

  return (
    <Flex
      style={{ padding: token.padding }}
      vertical
      align="center"
      gap="small"
    >
      <IconWithBackground
        size={ICON_BADGE_SIZE}
        color={color ?? token.colorPrimary}
      >
        {icon ?? <CircleSlash2 size={iconSizes.extraLarge} />}
      </IconWithBackground>

      {title ? (
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
      ) : null}

      {description ? (
        <Text type="secondary" style={{ maxWidth: 280, textAlign: 'center' }}>
          {description}
        </Text>
      ) : null}

      {footer}
    </Flex>
  )
}
